import React from 'react';
import { Box, Typography, Card, CardContent, TextField, Button } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const Profile: React.FC = () => {
  const { user } = useAuth();

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={700}>
        Profile
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Manage your account settings
      </Typography>

      <Card sx={{ maxWidth: 600 }}>
        <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              fullWidth
              label="Name"
              defaultValue={user?.name}
              disabled
            />
            <TextField
              fullWidth
              label="Email"
              defaultValue={user?.email}
              disabled
            />
            <TextField
              fullWidth
              label="Current Password"
              type="password"
              placeholder="••••••••"
            />
            <TextField
              fullWidth
              label="New Password"
              type="password"
              placeholder="••••••••"
            />
            <Button variant="contained" size="large">
              Update Profile
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Profile;

